import {useDispatch} from "react-redux";

import {PreferencesUpdateDataModal} from "../../application/components/preferences_steps/components/PreferencesUpdateDataModal";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {closeFlowVariantB, nextStepVariantB, RegistrationFlowStepVariantB} from "../state/registration_flow_variantB_slice";
import {RegistrationPreferencesModalVariantB} from "./registration_flow/RegistrationPreferencesModalVariantB";
import {AuthModalVariantB} from "./AuthModalVariantB";

export const RegistrationFlowVariantB = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlowVariantB);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStepVariantB({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            dispatch(closeFlowVariantB());
        }
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStepVariantB.REGISTRATION && <AuthModalVariantB />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PREFERENCES && (
                <RegistrationPreferencesModalVariantB
                    isOpen
                    isPropertyApplication={Boolean(flowState.propertyId)}
                    offerId={flowState.offerId}
                    onSuccess={flowState.userSource === UserSource.REGISTER_PROPERTY_PLAN ? handlers.onCloseFlow : handlers.onNextStep}
                />
            )}
            {flowState.currentStep === RegistrationFlowStepVariantB.UPDATED_PREFERENCES && <PreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
import {useDispatch} from "react-redux";

import {PreferencesUpdateDataModal} from "../../application/components/preferences_steps/components/PreferencesUpdateDataModal";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {closeFlowVariantB, nextStepVariantB, RegistrationFlowStepVariantB} from "../state/registration_flow_variantB_slice";
import {RegistrationPreferencesModalVariantB} from "./registration_flow/RegistrationPreferencesModalVariantB";
import {AuthModalVariantB} from "./AuthModalVariantB";

export const RegistrationFlowVariantB = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlowVariantB);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStepVariantB({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            dispatch(closeFlowVariantB());
        }
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStepVariantB.REGISTRATION && <AuthModalVariantB />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStepVariantB.PREFERENCES && (
                <RegistrationPreferencesModalVariantB
                    isOpen
                    isPropertyApplication={Boolean(flowState.propertyId)}
                    offerId={flowState.offerId}
                    onSuccess={flowState.userSource === UserSource.REGISTER_PROPERTY_PLAN ? handlers.onCloseFlow : handlers.onNextStep}
                />
            )}
            {flowState.currentStep === RegistrationFlowStepVariantB.UPDATED_PREFERENCES && <PreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
